
const Cert2CheckItems = [
  {"label": "理学療法士", "idx":"0"},
  {"label": "看護師", "idx":"1"},
  {"label": "日本スポーツ協会アスレティックトレーナー", "idx":"2"},
  {"label": "薬剤師", "idx":"3"},
  {"label": "JADA　公認スポーツファーマシスト", "idx":"4"},
  {"label": "健康運動指導士", "idx":"5"},
  {"label": "柔道整復師", "idx":"6"},
  {"label": "はり師", "idx":"7"},
  {"label": "きゅう師", "idx":"13"},
  {"label": "あん摩マッサージ指圧師", "idx":"14"},
  {"label": "臨床検査技師", "idx":"8"},
  {"label": "管理栄養士", "idx":"9"},
  {"label": "研究・教育機関のスタッフ", "idx":"10"},
  {"label": "大学院生・大学院修了者", "idx":"11"},
  {"label": "その他", "idx":"12"}
];

export default Cert2CheckItems;
